import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { environment } from "../../../environments/environment";
import { GenericResponseDto } from "../models/generic-response.dto";
import { QuotesNotesDto } from "../models/qoutes/quotesNotesDto";
import { QuotesNotes } from "../models/qoutes/quotesNotes";

@Injectable({
  providedIn: "root",
})
export class QuoteNotesGridService {
  private quoteManagementBaseURL = environment.baseUrl + "/QuotesManagement";

  constructor(private _http: HttpClient) {}

  getQuoteNotes(
    quoteId: string
  ): Observable<GenericResponseDto<QuotesNotesDto[]>> {
    return this._http.get<GenericResponseDto<QuotesNotesDto[]>>(
      this.quoteManagementBaseURL + `/GetQuotesNotes?SaleOrderId=` + quoteId
    );
  }

  AddQuoteNotes(payload: QuotesNotes): Observable<GenericResponseDto<boolean>> {
    return this._http.post<GenericResponseDto<boolean>>(
      this.quoteManagementBaseURL + "/AddQuotesNotes",
      payload
    );
  }

  deleteQuotesNotes(
    payload: number[]
  ): Observable<GenericResponseDto<boolean>> {
    return this._http.post<GenericResponseDto<boolean>>(
      this.quoteManagementBaseURL + "/DeleteQuotesNotes",
      payload
    );
  }
}
